/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { GET_NOTIFICATIONS } from "../actionTypes";

export const getNotificationList = (dispatch) => {
  dispatch({
    type: GET_NOTIFICATIONS,
  });
};
